module.exports = __webpack_public_path__ + "img/hanna-jani.dadac702.jpg";